const en_US = {
    //Common
    "SCREEN_BEAM":"ScreenBeam",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "EMAIL": "Email",
    "PHONE":"Phone",
    "PASSWORD":"Password",
    "CONFIRM_PASSWORD":"Confirm password",
    "ROLES": "Roles",
    "ROLE": "Role",
    "DELETE": "Delete",
    "RECEIVERS": "Receivers",
    "ID":"ID",
    "CMS": "CMS",
    "BORN_ON_DATE": "Born On Date",
    "EXPIRATION": "Expiration",
    "COMPANY": "Company",
    "COMPANY_NAME": "Company Name",
    "COMPANY_PHONE":"Company Phone",
    "COMPANY_ADDRESS":"Company Address",
    "FEATURES": "Features",
    "EDIT_COLUMNS":"Edit Columns",
    "ERROR":"ERROR: ",
    "SEARCH":"Search...",
    "CURRENTLY_VIEWING":"Currently Viewing: {dataCount}",
    "TOTAL_COUNT":"Total: {totalDataCount}",
    "NO_DATA_FOUND":"No data found",
    "DATA_LOADED":"Data finished loading",
    "DATA_NOT_LOADED":"Please wait for data to finish loading",
    "DATA_IS_LOADING": "Data is loading...",
    "SELECTED":"Selected: {selectedDataCount}",
    "SELECTED_TEXT":"Selected",
    "SYMBOL_COLON":":",
    "WARNING": "WARNING",
    "SAVE": "Save",
    "ADD": "Add",
    "BACK": "Back",
    "SUBMIT": "Submit",
    "ACCEPT":"Accept",
    "SAVE_CHANGES":"Save Changes",
    "EMPTY_FIELD_ERROR":"Please enter a ",
    "INVALID_EMAIL":"Please enter the correct email address",
    "BLOCK_EMAIL_DOMAIN":"This email's domain is blocked. Please enter another email address.",
    "INVALID_PHONE":"Please provide a valid phone number",
    "LIMIT_LENGTH_32":"Must be 1 - 32 characters",
    "LIMIT_LENGTH_64":"Must be 1 - 64 characters",
    "LIMIT_LENGTH_256":"Must be 1 - 256 characters",
    "LIMIT_LENGTH_9_64":"Must be 9 - 64 characters",
    "LIMIT_LENGTH_0_32":"Description character length cannot exceed 32",
    "EMAIL_LIMIT_LENGTH":"Email address length cannot exceed 255",
    "DESCRIPTION_LIMIT_LENGTH":"Description character length cannot exceed 256",
    "PASSWORD_NOT_MATCH":"Password do not match",
    "PASSWORD_CANNOT_SAME":"New password cannot be the same as the old password",
    "SELECT_PERMISSION_ERROR":"Select at least one Permissions",
    "SIGN_UP_ERROR":"An error occurred during signup.",
    "TENANT_REGISTERED_SUCCESS":"Tenant successfully registered!",
    "UNKNOWN_ERROR":"An unknown error occurred. Please try again later.",
    "INVALID_PASSWORD":"Password must be least one upper case English letter [A-Z], least one lower case English letter [a-z], at least one digit [0-9]. At least one special character.",
    "403_FORBIDDEN":"403: Forbidden {newline}You do not have the required permissions to access this route",
    "PASSCODE_EXPIRED_OR_INVALID": "Passcode is expired or invalid",
    "ACTIVATED": "Activated",
    "NOT_ACTIVATED": "Not Activated",
    //Roles: the display name of PermissionIds
    "255cffa0-ab88-4168-880e-6d60df62e4b3":"AlertPlus App Teacher View",
    "43b90cab-e566-4c92-91ec-4174a2a5cd6e":"AlertPlus App Officer View",
    "12e1f72c-420e-4298-b441-3859ce4fb65b":"Edit AlertPlus",
    "c3344f95-06ee-46f9-ac42-28a658cd6a4d":"Edit Orchestrate Server",
    "a1826c14-18bb-4f2f-bdec-2c9bac8ff7a3":"Edit CMS",
    "e5501406-af8c-4ccb-91e3-fc37b206b1be":"Edit User",
    "756801b1-e505-49a0-8eb8-88a66a13bd89":"Edit Licenses",
    "f420ec4c-0ebc-4ad9-8e89-77075bbae9d2":"Edit HW Warranty",
    "dcc0473d-e1cb-4ed7-88a3-9eaa83a68621":"View HW Warranty",
    "b78572a0-d7b5-4b1c-bb38-44c0b1310ef4":"Support",
	  "5837988d-cfff-41cd-aaab-6ad1e2c38e59":"Edit Message Manager",
	  "2605f8b1-dcd6-4e84-92b6-107418f0151e":"Message Manager Front Desk View",
    "b11eefbf-065a-470c-8204-e6ecb1aefb3b":"Edit Signage Plus",
    "3a8f7bd0-3427-4d18-9291-30041b0d28de":"Signage Owner",
    "d6ac5874-007b-4dec-ade0-942f5ab6dfe3":"Signage Teacher",

    //Description of Roles:
    "d4644451-03d1-4ffb-a6fe-5bc48220d539-DESCRIPTION": 'Issue and manage alerts on web dashboard and phone app',
    "bffef2c0-001a-442d-b032-e35ea45a8bdb-DESCRIPTION": 'Assign users to sites, manage alert templates, and set moderation mode',
    "e5c5013d-04ba-4727-9a15-16508e6217af-DESCRIPTION": 'Grant access to phone app to issue alerts',
    "6e61c47e-7e58-426e-815c-70701b9473cc-DESCRIPTION": 'Access to dashboard and settings',
    "a897f327-94b5-4cb6-b60c-bf43970b9e17-DESCRIPTION": 'Permission to bind or unbind ScreenBeam CMS instances from or to Cloud.',
    "2d3308e8-5c0b-4413-9957-1e8503dd3e21-DESCRIPTION": 'Manage user accounts for all features',
    "49f3f591-f440-4964-91aa-f6681ef3dc0b-DESCRIPTION": 'Manage licenses',
    "eb438a07-8e36-40a8-98b5-c24e85b482a9-DESCRIPTION": 'Configure settings, users, and group management',
    "8e40fe94-e3ec-4f8c-8275-3d83741427ed-DESCRIPTION": 'Issue, schedule, and manage announcements to receivers',
    "d91cfd7e-2952-4c35-9ba0-a0fd7f644472-DESCRIPTION": 'View hardware warranty page',
    "038e43fa-552f-42db-b3ba-db176b6e53ee-DESCRIPTION": 'Assign users to sites, manage alert templates, and set moderation mode',
    "76047cb2-bad6-4562-a2ca-11a7ace34fe7-DESCRIPTION": 'Issue and manage signages on web',
    "f7e3561d-5b76-4f84-8d82-1e31e0e8682c-DESCRIPTION": 'Grant access to web to issue signage',

    //Role Name of Roles:
    "c3c29b52-41d6-45ec-8064-2c558d1a5b2f-ROLENAME":'Account Owner',
    "d4644451-03d1-4ffb-a6fe-5bc48220d539-ROLENAME": 'Officer',
    "bffef2c0-001a-442d-b032-e35ea45a8bdb-ROLENAME": 'Alert Plus Administrator',
    "e5c5013d-04ba-4727-9a15-16508e6217af-ROLENAME": 'Teacher',
    "6e61c47e-7e58-426e-815c-70701b9473cc-ROLENAME": 'Orchestrate Administrator',
    "a897f327-94b5-4cb6-b60c-bf43970b9e17-ROLENAME": 'CMS Administrator',
    "2d3308e8-5c0b-4413-9957-1e8503dd3e21-ROLENAME": 'User Administrator',
    "49f3f591-f440-4964-91aa-f6681ef3dc0b-ROLENAME": 'License Manager ',
    "eb438a07-8e36-40a8-98b5-c24e85b482a9-ROLENAME": 'Message Manager Administrator',
    "8e40fe94-e3ec-4f8c-8275-3d83741427ed-ROLENAME": 'Front Office Personnel',
    "d91cfd7e-2952-4c35-9ba0-a0fd7f644472-ROLENAME": 'Warranty Viewer',
    "038e43fa-552f-42db-b3ba-db176b6e53ee-ROLENAME": 'Signage Administrator',
    "76047cb2-bad6-4562-a2ca-11a7ace34fe7-ROLENAME": 'Signage Owner',
    "f7e3561d-5b76-4f84-8d82-1e31e0e8682c-ROLENAME": 'Signage Teacher',

    //Feature Name of Features:
    "1f0f6ccd-146d-44df-a379-54eccbeb473e-FEATURENAME": 'Alert Plus',
    "fccfc805-26d3-4bd9-8374-be419935957d-FEATURENAME": 'ScreenBeam Cloud',
    "587e8e6a-ee08-4c63-b812-a4f60204e0b1-FEATURENAME": 'Orchestrate',
    "f07b57b8-a1a0-470a-8dc8-6811e649eab2-FEATURENAME": 'Message Manager',
    "672597bc-8086-4457-b036-690c985ef829-FEATURENAME": 'ScreenBeam Cloud',
    "9aeaf825-0152-49b0-aa38-79ae9998ef6e-FEATURENAME": 'Signage Plus',

    //Confirm Modal
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "CONFIRM_BTN":"Confirm",
    "CONFIRMATION":"Confirmation",
    "CONFIRM_MESSAGE":"Are you sure you want to permanently delete {counts} {dataType}?",
    "CONFIRM_ACCOUNT_DELETE":"WARNING: Deleting the {dataType} is permanent, and all associated data will be deleted. Proceed?",
    "CONFIRM_ALERT_CLEAR":"Are you sure you want to clear the alert?",
    "THIS_ACTION_CANNOT_BE_UNDONE":"This action cannot be undone",

    //PageType, title
    "Users": "Users",
    "Account Management": "Account Management",
    "Alert Plus": "Alert Plus",
    "Manage Alerts": "Manage Alerts",
    "Log": "Log",
    "Templates": "Templates",
    "Alert Plus Users": "Alert Plus Users",
    "CMS Management": "CMS Management",
    "Companies": "Companies",
    "Licenses": "Licenses",
    "User Roles":"User Roles",
    "Hardware Warranty": "Hardware Warranty",
    "API Key": "API Key",
    "Site Mapping": "Site Mapping",
    "Queued Messages":"Queued Messages",
    "Latest Scheduled Messages":"Latest Scheduled Messages",
    "Status":"Status",
    "History":"History (Last 50 Messages)",
    "Logs":"Logs",
    "Receivers and Signage Control": "Receivers and Signage Control",

    //Login page
    "SCREENBEAM_CLOUD":"ScreenBeam Cloud",
    "EMAIL_ADDRESS":"Email address",
    "FORGOT_PASSWORD":"Forgot password?",
    "LOG_IN":"Log In",
    "INVALID_PARAMETERS":"Invalid parameters.",
    "INCORRECT_USERNAME_PASSWORD_ROLES":"Incorrect username or password or no roles assigned or email has not been verified.",
    "SERVER_ERROR":"Server error.",

    //Forgot Password Page
    "FORGOT_PASSWORD_TITLE":"Forgot password?",
    "FORGOT_PASSWORD_DESCRIPTION":"Please contact your ScreenBeam Service Portal Account Owner to reset your password. If you are the Account Owner please contact ScreenBeam Support.",
    "FORGOT_PASSWORD_EMAIL_SENT": "If {email} is registered with Screenbeam Cloud an email has been sent. Follow the instructions in the email to reset your password.",

    //Reset Password Page
    "RESET_PASSWORD": "Reset password",
    "RESET_PASSWORD_SUCCESS": "Successfully changed password.",

    //Activate User Page
    "ACTIVATE_USER_SUCCESS": "Successfully changed password and activated user.",

    //Resend Verification Email page
    "RESEND_VERIFICATION_EMAIL":"Resend Verification Email",
    "RESEND_VERIFICATION_EMAIL_SENT":"Check your email for a verification link.",
    "VERIFICATION_EMAIL_LINK_EXPIRED":"Verification link has expired, click the button below to resend a verification link to {email}",
    "RESEND":"Resend",
    "VERIFY_USER":"Verify User",

    //SSO Signin
    "PERMISSIONERROR":"You do not have permission to register CMSE to your ScreenBeam Cloud tenant",
    "INCORRECTCREDENTIALS":"Incorrect email or password",
    "INVALIDCMSID":"Please obtain the correct CMS ID",

    //Navbar
    "EDIT_ACCOUNT_INFO": "Edit account info",
    "ENTER_PHONE_NUMBER":"Enter phone number",
    "LOG_OUT":"Log out",
    "LOG_OUT_SUCCESS":"Successfully logged out",
    "ENGLISH":"English",
    "CHINESE":"Chinese",

    //Sidebar
    "DASHBOARD": "Dashboard",
    "DASHBOARD-ADMIN": "Dashboard - Admin",
    "DASHBOARD-OWNER": "Dashboard - Owner",
    "DASHBOARD-TEACHER": "Dashboard - Teacher",
    "USER_MANAGEMENT": "User Management",
    "ACCOUNT_MANAGEMENT":"Account Management",
    "LICENSE_MANAGEMENT": "License Management",
    "CMS_MANAGEMENT": "CMS Management",
    "ALERTS_PLUS": "Alerts Plus",
    "ORCHESTRATE": "Orchestrate",
	"MESSAGE_MANAGER": "Message Manager",
    "HARDWARE_WARRANTY": "Hardware Warranty",
    "SETTINGS": "Settings",
    "SUPPORT":"Support",
    "MISCELLANEOUS":"Miscellaneous",
    
    "APPLICATION_LIBRARY":"Applications Library",

    //User Management
    "ADD_USER": "Add User",
    "IMPORT_USERS": "Import Users",
    "IMPORT_USERS_ACTIVATED": "Import Users (Activated)",
    "SET_ROLES": "Set Roles",
    "ADD_USER_SUCCESS":"Successfully added user(s)!",
    "ADD_USER_FAILED":"Failed to add user: {errorMsg}",
    "ADD_USER_ITSELF_LIMIT":"Error: You cannot add this user again.",
    "EDIT_USER_SUCCESS":"Successfully edited user!",
    "EDIT_USER_FAILED":"Failed to edit user: {errorMsg}",
    "DELETE_USER_SUCCESS":"User deleted successfully!",
    "DELETE_USER_FAILED":"Failed to delete user: {errorMsg}",
    "DELETE_USERS_FAILED":"Failed to delete users: {errorMsg}",
    "DELETE_OWNER_ERROR":"Cannot delete account owner",
    "DELETE_USER_NO_ELIGIBLE_USERS":"No eligible users to delete.",
    "COUNT_USERS_DELETED_SUCCESS":"{userCounts} users deleted successfully!",
    "COUNT_USERS_EDITED_SUCCESS":"{userCounts} users edited successfully!",
    "SUBMIT_ERROR":"Please fill out all fields",
    "PASSWORDS_NOT_MATCH":"Passwords did not match",
    "NO_USERS_SELECTED":"No users selected",
    "NO_ROLES_SELECTED":"No roles selected",
    "NO_USERS_TO_DELETE":"No users to delete.",
    "EDIT_USER_ROLES_SUCCESS":"Successfully assign roles to user(s)!",
    "EDIT_USER_ROLES_FAILED":"Failed to edit user-roles: {errorMsg}",
    "RESENT_TO_EMAIL":"Successfully resent verification link to {email}",
    "RESENT_TO_EMAIL_FAIL":"Failed to resend verification link to {email}",
    //User Modal
    "EDIT_USER":"Edit User",
    //Role Modal
    "ASSIGN_ROLES":"Assign Roles",
    "ROLE_DESCRIPTION":"Responsibility",
    //Import Modal
    "IMPORT_USERS_EXAMPLE":"Import a set of users via CSV {newline}Phone must be in E.164 format {newline}Example:",
    "IMPORT_USERS_SUCCESS": "Successfully imported users. Successful: {successfulCount}, Failing: {failingCount}, Duplicates: {duplicateCount}.",
    "IMPORT_USERS_PARTIAL_SUCCESS":"Some rows failed to import",
    "IMPORT_USERS_FAILED":"Failed to import users",
    "IMPORT_USERS_SUCCESSFUL_ROWS":"Successful Rows:",
    "IMPORT_USERS_FAILED_ROWS":"Failing Rows:",
    "IMPORT_USERS_DUPLICATE_ROWS":"Duplicate Users:",
    "INVALID_FILE_EXTENSION":"Invalid file extension: {extension}",
    "FILE_TYPE_NOT_SUPPORTED":"File type not supported",
    "INSUFFICIENT_STORAGE_SPACE":"You have exceeded your upload storage capacity. Delete some of your Media files.",
    "PLEASE_SELECT_FILE": "Please select a file.",
    "UPLOAD_A_CSV":"Upload a CSV",
    "DRAG_AND_DROP_OR_CHOOSE_FILE": "Drag and drop a file here, or {chooseFile}.",
    "CHOOSE_FILE": "choose file",
    "CSV_TEMPLATE": "CSV Template",
    "CSV_TEMPLATE_DESCRIPTION": "You can download the attached example and use it as a starting point for your file.",
    "DOWNLOAD": "Download",
    //Account Management
    "ADD_ACCOUNT": "Add Account",
    "EDIT_ACCOUNT":"Edit account",
    "DELETE_ACCOUNT": "Delete Account",
    "DELETE_ACCOUNT_WARNING": "Deleting the account is permanent and all associated data will be deleted. Proceed?",
    "ACCOUNT_OWNER":"Account Owner",
    "CREATE_AN_ACCOUNT":"Create an account",
    "EDIT_ACCOUNT_FAILED":"Failed to edit account. Please try again later.",
    "EDIT_ACCOUNT_SUCCESS":"Successfully edited account!",
    "DELETE_ACCOUNT_SUCCESS":"Successfully deleted accounts",
    "DELETE_ACCOUNT_FAILED":"Failed to delete accounts",
    "COUNT_ACCOUNTS_DELETED_SUCCESS":"{count} accounts deleted successfully!",
    "ADDED_ACCOUNT_SUCCESS":"Successfully added account",
    "ADDED_ACCOUNT_FAILED":"Failed to add account",
    
    //License Management
    "ACTIVATE": "Activate",
    "DEACTIVATE": "Deactivate",
    "REFRESH": "Refresh",
    "REFRESH_LICENSES_SUCCESS":"Successfully refreshed licenses!",
    "REFRESH_LICENSES_FAILED":"Failed to refresh licenses",
    "LICENSE": "License",
    "ACTIVATION_KEY": "Activation Key",
    "ACTIVATE_LICENSE":"Activate License",
    "LICENSE_KEY":"License key",
    "REMAINING": "Remaining",
    "SEATS": "Seats",
    "SEATS_USED":"Seats Used",
    "LICENSE_EULA_MODAL_TITLE":"Please review the Terms of Service carefully and click Accept to continue.",
    "LICENSE_READ_AND_AGREE":"I agree to the End-User License Agreement",
    "LICENSE_ALREADY_ACTIVATED":"A license for this feature has already been activated. Unable to activate new license. Please contact support for more details at support@screenbeam.com",
    "ACTIVATION_KEY_INVALID":"Activation key invalid",
    "DEACTIVATE_LICENSE_KEY_SUCCESS":"Successfully deactivated license(s)!",
    "DEACTIVATE_LICENSE_KEY_FAILED":"Failed to deactivate license(s): {info}",
    "LICENSE_ACTIVATED_SUCCESS":"Successfully activated license!",
    "LICENSE_ACTIVATED_INFO":"Activation in progress, please wait...",

    //Cms Management
    "STATUS": "Status",
    "LAST_SEEN": "Last Seen",
    "NAME": "Name",
    "SITES": "Sites",
    "VERSION": "Version",
    "LOGS": "Logs",
    "DELETE_CMSES_SUCCESS":"Successfully deleted CMSes!",
    "DELETE_CMSES_FAILED":"Failed to delete CMSes",

    //Alerts Plus
    "SITE": "Site",
    "ALERTS_LOG":"Alerts Log",
    "ADD_ALERTS_PLUS_USER":"Add Alerts Plus User",
    "EDIT_ALERTS_PLUS_USER":"Edit Alerts Plus User",
    "RESEND_VERIFICATION":"Resend Verification",
    "ADDED_USER_SUCCESS":"Successfully added user!", 
    "CHANGED_SUCCESS":"Successfully changed!",
    "SUCCESS_RESENT_VERIFICATION_TO":"Successfully resent verification to: {email}",
    "SELECT_CMS": "Select CMS",
    "SELECT_A_CMS":"Select a CMS",
    "NO_CMSE_AVAILABLE":"No CMSes available",
    "SELECT_SITES":"Select Sites",
    "NO_SITES_AVAILABLE":"No sites available",  
    "NO_CMS_SELECTED": "At least one CMS must be selected",
    "NO_SITES_SELECTED": "At least one site must be selected",
    "ALERT_TEMPLATE":"Alert Template",
    "ADD_TEMPLATE":"Add Template",
    "Create Alert Templates":"Create Alert Templates",
    "DELETE_APLUS_TEMPLATES_SUCCESS":"Successfully deleted templates",

    //Alert Plus - Updated
    "MANAGE_ALERTS":"Manage Alerts",
    "TRIGGER_ALERT":"Trigger Alert",
    "SEE_ALL_REQUESTS":"See all requests",
    "LOCKDOWN":"Lockdown",
    "HOLD":"Hold",
    "SECURE":"Secure",
    "EVACUATE":"Evacuate",
    "SHELTER":"Shelter",
    "FIRE":"Fire",
    "WEATHER":"Weather",
    "ALL_CLEAR": "All Clear",
 
    "ALERTS":"Alerts",
    "CLASSROOM_DETAILS":"Classroom Details",
    "ALERT_ENDED": "Alert Ended",
    "REDIRECT_ALERT_TITLE": "Alert Ended - Redirecting",
    "REDIRECT_ALERT_ENDED": "The current alert has ended, and you will be redirected to the alert management page shortly. Please confirm to proceed.",
    "NO_ALERTS":"No alerts",
    "ALERT_REQUESTS":"Alert Requests",
    "ALERT_IN_PROGRESS":"Alert In Progress",
    "REQUESTS": "Requests",
    "CLEAR_ALERT":"Clear Alert",
    "USER_STATUS":"User Status",
    "SELECT_SITES_FOR_ALERT":"Select Sites for Alert",
    "SELECT_ALL":"Select All",
    "DESELECT_ALL":"Deselect All",
    "TEACHERS_NEED_APPROVAL": "Teachers need approval",
    "TEACHERS_NEED_APPROVAL_DESCRIPTION": "Teachers' alerts will be sent to a security officer for approval before being triggered.",
    "TEACHERS_TRIGGER_IMMEDIATELY": "Teachers trigger immediately",
    "TEACHERS_TRIGGER_IMMEDIATELY_DESCRIPTION": "Teachers alerts will be triggered immediately without approval.",
    "ASSIGN_CMS_SITE": "Assign CMS/Site",
    "TEACHERS_ASSIGNED_ONE_SITE": "Note: Teachers MUST be assigned to only one site.",
    "PERMISSIONS": "Permissions",
    "ALERT_NAME": "Alert Name",
    "SITE_NAME": "Site Name",
    "BUILDING_NAME": "Building Name",
    "START_TIME": "Start Time",
    "END_TIME": "End Time",
    "TRIGGERED_BY": "Triggered By",
    "CLEARED_BY": "Cleared By",
    "TEMPLATE": "Template",
    "TEMPLATES": "Templates",
    "INSTRUCTIONS": "Instructions",
    "EXPORT_AS_CSV": "Export as CSV",
    "MODERATION_OPTIONS": "Moderation Options",
    "NO_SITES": "No Sites Found",
    "TEACHER": "Teacher",
    "PHONE_NUMBER": "Phone Number",
    "ALERT_PLUS_ROLE": "Alert+ Role",
    // ALERTS PLUS - SUCCESS AND ERROR MESSAGES
    "MODERATION_OPTIONS_SAVE_SUCCESS": "Moderation options saved",
    "MODERATION_OPTIONS_SAVE_FAIL": "Failed to save moderation options",
    "ASSIGN_SITE_SUCCESS": "Successfully assigned site(s)",
    "ASSIGN_SITE_FAIL": "Failed to assign site(s)",
    "ALERT_TRIGGER_SUCCESS": "Alert triggered successfully",
    "ALERT_TRIGGER_FAIL": "Failed to trigger alert",
    "ALERT_DISMISS_SUCCESS": "Alert dismissed successfully",
    "ALERT_DISMISS_FAIL": "Failed to dismiss alert",
    "ALERT_CLEAR_SUCCESS": "Alert cleared successfully",
    "ALERT_CLEAR_FAIL": "Failed to clear alert", 

    //Alerts Plus Template
    "ALERT_PLUS_TEMPLATE_MAKER":"Screenbeam Alert Plus Template Maker", 
    "ALERT_NAME":"Alert Name",
    "SET_SITE": "Set Site",
    "UPLOAD_AN_ICON":"Upload an icon(.png, .jpg)...",
    "ALERT_PLUS_SET_ICONS_WARNING":"Ensure that icons can be clearly seen in both light and dark backgrounds",
    "ALERT_PLUS_IMAGE_WARNING":"Image aspect ratio will be maintained",
    "ICON":"Icon",
    "IMAGE":"Image",
    "DURATION":"Duration",
    "ALERT_PLUS_MAKE_PRESET":"Make Preset?",
    "DURATION_INDEFINITE":"Indefinite",
    "DURATION_1_MINUTE":"1 minute",
    "DURATION_MINUTES":"{number} minutes",
    "DURATION_1_HOUR":"1 hour",
    "DURATION_HOURS":"{number} hours",
    "NO":"No",
    "ALERT_SOUND":"Alert Sound",
    "CREATE_ALERT":"Create Alert",
    "UPDATE_ALERT":"Update Alert",
    "ALERT_PLUS_CLOSE_WINDOW_BTN":"Close Window",
    "ALERT_PLUS_CREATE_EDIT_SUCCESS":"Successfully {methodText} template. ",
    "AUTO_CLOSE_WINDOW":"This window will automatically close.",

    "TRIGGER_ALERT":"Trigger Alert",

    //Orchestrate
    "GO_TO_ORCHESTRATE":"Go to Orchestrate",
	
    //Message Manager
    "SBMM_USER_MANAGEMENT":"User Management",
    "SBMM_GROUP_MANAGEMENT":"Group Management",
    "SBMM_LOGS":"Logs",
    "SBMM_STATUS":"Status",
    "SBMM_CREATE_MESSAGE":"Create Message",
    "NO_FEATURES_SELECTED": "At least one feature must be selected",
    "FEATURE":"Feature",
    "CMS_SITE_CONFLICT": "Users can only be assigned to one CMS at a time. Some selected users already have sites from a different CMS.",
    "ONLINE": "Online",
    "IN_PROCESS": "In-process",
    "OFFLINE": "Offline",

    //Hardware Warranty
    "MODEL_NAME": "Model Name",
    "MAC": "MAC",
    "MACs": "MACs",
    "SERIAL_NUMBER": "Serial Number",
    "ACCOUNT_EMAIL":"Account Email",
    "OWNER_EMAIL":"Owner Email",
    "EDIT_EXPIRATION":"Edit Expiration",
    "DELETE_RECEIVER":"Delete Receiver",
    "IMPORT_RECEIVERS":"Import Receivers",
    "SHOW_RECEIVERS":"Show Receivers",
    "VIEW_RECEIVERS":"View Receivers",
    "EDIT_RX_EXPIRATION_SUCCESS":"Successfully edited receiver expiration",
    "DELETED_RECEIVERS_SUCCESS":"Successfully deleted receivers",
    "IMPORT_RECEIVERS_SUCCESS":"Successfully imported receivers",
    "SELECT_A_COMPANY":"Select a Company...",
    "SELECT_FILE":"Select File",
    "FEEDBACK_LOOKS_GOOD":"Looks good!",
    "IMPORT":"Import",
    "EDIT_RECEIVERS":"Edit Receivers",
    "RECEIVER_EXPIRATION":"Receiver Expiration",
    //Import Receivers
    "IMPORT_RECEIVERS_ERROR":"Something went wrong with the import. Please try again.",
    "SELECTE_COMPANY_FOR_IMPORT_RECEIVERS":"Both company and a file must be selected for the import.",

    //Roles
    "ADD_ROLES": "Add Roles",
    "PERMISSIONS": "Permissions",
    "#_USERS": "# Users",
    "DESCRIPTION": "Description",
    "EDIT_ROLE":"Edit Role",
    "ADD_ROLE":"Add Role",
    "ROLE_NAME":"Role Name",
    "DELETE_ROLES_ERROR":"No roles selected for deletion or cannot delete the Account Owner role",
    "DELETE_ROLES_FAILED_INFO":"Failed to delete roles: {info}",
    "ROLE_DELETE_SUCCESS": "Role deleted successfully!",
    "COUNT_ROLES_DELETE_SUCCESS":"{count} Roles deleted successfully!",
    "ROLE_ADDED_SUCCESS":"Role added successfully",
    "ROLE_UPDATED_SUCCESS":"Role updated successfully",

    //Settings
    "SETTINGS_TITLE": "Settings",
    "GLOBAL_POLICIES": "Global Policies",
    "PASSWORD_LENGTH": "Password Length",
    "INVALID_PASSWORD": "Invalid Password: Must contain uppercase, lowercase, numbers, and special chars",
    "MINIMUM_LENGTH": "Minimum Length",
    "REQ_PASSWORD_CHANGE": "Require password change on first login",
    "TWO_FA": "Two-factor authentication",
    "PREFERENCES": "Preferences",
    "DARK_MODE": "Dark Mode",
    "MISSING_PASSWORD_MINI_LENGTH":"Missing password minimum length.",
    "PASSWORD_NOT_MEET_MINI_LENGTH":"Password does not meet minimum length.",
    "SUCCESS":"Success!",
    "CURRENT_PASSWORD_INCORRECT":"Current password is incorrect",
    //Change Password Modal
    "CHANGE_PASSWORD":"Change Password",
    "CURRENT_PASSWORD":"Current Password",
    "NEW_PASSWORD":"New Password",
    "FIELD_CANNOT_EMPTY":"Field cannot be empty",
    "LOGGED_OUT_SUCCESS":"You will be logged out on success",
    "DONE_BTN":"Done",
    //Check Email Modal
    "CHECK_EMAIL_FOR_RESET_PASSWORD":"Please check your email for the link to reset your password.",
    "SEND_EMAIL_FAILED":"Failed to send email.",
    "SEND_EMAIL_SUCCESS":"Email successfully sent!",

    //Support
    "ACCOUNT_NAME":"Account Name",
    "ACCOUNT_ID":"Account ID",
    "CMSES":"CMSes",
    "COMPANY_ID":"Company ID",
    "WITH_ROLES":"With roles",
    "WITH_BASE_PERMISSIONS":"With base permissions",
    "RECEIVERS_PER_PRODUCT":"Receivers per Product",
    "TOTAL_RECEIVERS":"Total receivers",
    "CUSTOMERS_REGISTERED_RXS":"Customers who have registered receivers",

    // Support Tools
    "SUPPORT_TOOLS":"Support Tools",
    "USER_IMPORT_AND_ACTIVATION":"User Import and Activation",
    "USER_NOT_FOUND":"User not found",
    "USER_ACTIVATED_SUCCESS":"User activated successfully",
    "USER_ACTIVATED_FAIL":"Failed to activate user",
    "ACTIVATE_USER":"Activate User",
    "IMPORT_USERS_FROM_CSV":"Import Users From CSV",

    // Configuration
    "CONFIGURATION": "Configuration",
    "SB_CLOUD_API_KEY": "SB Cloud API Key",
    "RAPTOR_CLIENT_UID": "Raptor Client UID",
    "GENERATE_API_KEY": "Generate API Key",
    "SINGLEWIRE_TOKEN": "Singlewire Token",
    "SINGLEWIRE_TOKEN_DESC": "Please refer to the your documentation on how to Configure Singlewire Connect",
    "NO_SINGLEWIRE_TOKEN": "No Singlewire token found. Click below to authenticate with Singlewire.",
    "AUTHENTICATE_WITH_SINGLEWIRE": "Authenticate with Singlewire",
    "AUTHENTICATING": "Authenticating...",
    "REFRESH_TOKEN": "Refresh Token",
    "singlewireTokenSuccess": "Successfully obtained Singlewire token",
    "singlewireTokenError": "Failed to obtain Singlewire token",
    "oauthStartError": "Error starting authentication flow",
    "tokenApiFetched": "Successfully fetched from token API - check console",
    "tokenApiFailed": "Failed to fetch from token API",
    "NO_API_KEY": "No API Key",
    "NO_TOKEN": "No Token",

    // Site Mapping
    "SITE_MAPPING": "Site Mapping",
    "SCREENBEAM_SITE_NAME": "ScreenBeam Site Name",
    "RAPTOR_BUILDING_NAME": "Raptor Building Name",
    "ASSIGN_BUILDING": "Assign Building",
    "ASSIGN_BUILDINGS": "Assign Buildings",
    "ENTER_BUILDING_NAME": "Enter building name...",
    "BUILDING_NAME": "Building Name",
    "RAPTOR_BUILDING_NAME_DESC": "The building name must be the exact same as in Raptor in order to be linked.",
    "SITE_MAPPING_SUCCESS": "Site mapping successfully updated",
    "SITE_MAPPING_ERROR": "Failed to update site mapping",
    "SITES_UPDATED": "Sites updated successfully",
    "SITES_UPDATED_FAILED": "Failed to update sites",
    "BUILDING_NAME_REQUIRED": "Building name is required",
    "SELECT_CMS": "Select CMS",
    "FAILED_TO_FETCH_CMS_OPTIONS": "Failed to fetch CMS options",
    "NO_SITES_AVAILABLE_FOR_SELECTED_CMS": "No sites available for the selected CMS",
    "ERROR_PROCESSING_SITES_DATA": "Error processing sites data",
    "SUCCESS_DEASSIGN_BUILDINGS": "Successfully deassigned buildings",
    "FAILED_TO_DEASSIGN_BUILDINGS": "Failed to deassign buildings",
    "SELECT_BUILDING": "Select a building",
    "RAPTOR_BUILDING_SELECT_DESC": "Select a building from your Raptor system to map to the selected sites",

    // SINGLEWIRE 
    "SINGLEWIRE_SITES_LOADED": "Successfully loaded Singlewire sites",
    "SINGLEWIRE_SITE_SELECT_DESC": "Select a site from your Singlewire system to map to the selected sites",
    "SINGLEWIRE_SITE_NAME": "Singlewire Site Name",
    "SINGLEWIRE_SITE_ID": "Singlewire Site ID",
    "SINGLEWIRE_NO_TOKEN": "No Singlewire token found. Please configure your token first.",
    "SINGLEWIRE_INVALID_TOKEN": "Invalid or expired Singlewire token. Please update your token.",
    "SINGLEWIRE_SITES_ERROR": "Failed to fetch Singlewire sites",
    "SINGLEWIRE_TOKEN_EXPIRATION": "IMPORTANT: This token will expire 1 year from creation. Please renew token on your service account before it expires.",
    "SINGLEWIRE_SITE_NAME_DESC": "The site name must be the exact same as in Singlewire in order to be linked.",

    //CMSE CONNECT TO CLOUD
    "CMSE_CONNECT_SUCCESS":"ScreenBeam Cloud Connection Successful",
    "RETURN_TO_CMSE_DASHBOARD":"Return to CMS Dashboard",
    "CONNECT_TO_CLOUD_BTN_DESCRIPTION":"Connect to ScreenBeam Cloud to access premium features and to manage licenses",
    "CONNECT_TO_CLOUD_BTN_LABEL":"Connect Now",
    "BACK_BTN":"Back",
    "CMSE_LOGIN_TITLE":"Log in to ScreenBeam Cloud",
    "CMSE_LOGIN_SUB_TITLE":"Sign-in to connect your cloud to CMS",
    "FORGOT_LOGIN_PASSWORD":"Forgot login/password",
    "DONT_ACCOUNT":"Don't have an account?",
    "SIGN_UP":"Sign Up",
    "CONNECT_BTN":"Connect",
    "TERMS_AND_CONDITIONS":"Terms and Conditions",
    "AGREE_TERMS_AND_CONDITIONS":"I agree to these terms and conditions",
    "CONTINUE_BTN":"Continue",
    "CMSE_SIGN_UP_TITLE":"Sign Up for ScreenBeam Cloud",
    "CMSE_SIGN_UP_SUB_TITLE":"Create your account to unlock the full potential of your devices",
    "CREATE_ACCOUNT_BTN":"Create Account",
    "VERIFY_ACCOUNT_TITLE":"Verify your account",
    "VERIFY_ACCOUNT_SUB_TITLE":"Please enter the code that was sent to your email: {email}",
    "ENTER_CODE":"Enter Code",
    "DIDNT_RECV_CODE":"Didn't receive the code?",
    "RESEND_CODE":"Resend Code",
    "ASSIGN_NAME_FOR_CMSE":"Assign a friendly name for your CMS",
    "ACCOUNT_CREATED_SUCCESS":"Account created successfully",
    "CONNECTIONG_TO_CLOUD":"Connecting to Cloud...",

    //Messenger Dashboard
    "FIRMWARE_UPDATE":"Firmware Update:",
    "Banner_INfo":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed lorem et est tempor consectetur. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed lorem et est tempor consectetur.",
    "UPDATE_NOW":"update now",
    "SCHEDULED_MESSAGES":"Scheduled Messages",
    "LATEST_SCHEDULED_MESSAGES":"Latest Scheduled Messages",
    "CREATE_MESSAGE":"Create Message",
    "MESSAGE_STATUS":"Status",
    "SELECT_MESSAGE_TYPE":"Select Message Type",
    "SELECT_MESSAGE_STYLE":"Select Message Style",
    "TICKER":"Ticker",
    "HALF_SCREEN":"Half-Screen",
    "FULL_SCREEN":"Full Screen",
    "TEXT_MESSAGE":"Text Message",
    "MESSAGE_IMAGE":"Image",
    "NUMBER_OF_ROTATION":"Number Of Rotation <span class='range-style'>(1-5)</span>",
    "SELECT_DISPLAY_DURATION":"Select Display Duration  <span class='range-style'>(1-10 minutes)</span>",
    "MESSAGE": "Message",
    "TITLE":"Title",
    "SELECT_RECEIVERS":"Select Receivers",
    "DELIVER_MESSAGE":"Deliver Message",
    "JPG_FILE_2MB": "JPG file ≤ 2Mb",
    "NOW":"Now",
    "SCHEDULE":"Schedule",
    "SEND_MESSAGE":"Send Message",
    "RECURRING":"Recurring",
    "MESSAGE_SUCCESS":"Message Sent Successfully!",
    "MESSAGE_SUCCESS_DESCRIPTION":"Your Message Has Been Sent Successfully.",
    "MESSAGE_FAILED":"Sorry!",
    "MESSAGE_FAILED_DESCRIPTION":"Your Message Could Not Be Sent To The Selected Receivers. Please Retry Or Select Different Receivers.",
    "CONTINUE":"Continue",
    "ADD_NEW_GROUP":"Add New Group",
    "GROUP_TYPE":"Group Type",
    "GROUP_NAME":"Group Name",
    "ASSIGN_RECEIVERS":"Assign Receivers",
    "DE_ASSIGN_RECEIVERS":"De-Assign Receivers",
    "ASSIGN_USERS_TO_GROUP":"Assign Users To Group",
    "ASSIGN_USERS_TO_GROUPS_FAILED":"Failed to assign users to group",
    "ASSIGN_USERS_TO_GROUP_INFO":"Are You Sure To Assign The Selected Users To The Selected Group?",
    "USERS_IN_RECEIVER":"Users In Receiver",
    "NO_USERS_IN_RECEIVER":"No Users In Receiver",
    "NO_USERS_IN_GROUP":"No Users In Group",
    "ASSIGN_USERS_TO_GROUP_SUCCESS":"Users assigned to group successfully",
    "ASSIGN_USERS_TO_GROUP_FAILED":"Failed to assign users to group",
    "VIEW_USERS":"View Users",
    "GROUP_MANAGEMENT":"Group Management",
    "RELEASE_USERS":"Are You Sure To Release Users?",
    "RELEASE_USERS_INFO":"please select valid option below.",
    "RECEIVERS_GROUPS":"Receivers Groups",
    "ASSIGN_GROUPS":"Assign Groups",
    "MES_DRAG_AND_DROP_OR_CHOOSE_FILE": "Drag and drop a file here, {br}or {br}{chooseFile}.",
    "MES_CHOOSE_FILE_TEXT": "Choose File",
    "ARE_YOU_SURE":"Are You Sure?",
    "ARE_YOU_SURE_DESCRIPTION":"Are You Sure To Delete The Selected User?",
    "NEW_GROUP":"New Group",
    "SUB_GROUP":"Sub-group",
    "PARENT_GROUP_NAME":"Parent Group Name",
    "SUB_GROUP_NAME":"Sub-Group Name",
    "SEARCH_MESSAGE":"Search Message ...",
    "SELECT_TIME":"Select Time",
    "SELECT_DATE":"Select Date",
    "TYPE_YOUR_TITLE":"Type Your Title",
    "TYPE_YOUR_MESSAGE":"Type Your Message...",
    "SELECT_ALL_RECEIVERS":"Select All Receivers",
    "TYPE":"Type",
    "SENT":"Sent",
    "GROUPS":"Groups",
    "NEXT_RUN":"Next Run",
    "DATE_AND_TIME":"Date And Time",
    "DELIVERY":"Delivery",
    "DEVICE_NAME":"Device Name",
    "DELETE_MESSAGE":"Are You Sure To Delete This Message?",
    "DELETE_MESSAGE_DESCRIPTION":"This Will Delete The Message Permanently. You Can Not Undo This Action.",
    "ADD_GROUP_SUCCESS":"Group Added Successfully!",
    "ADD_GROUP_FAILED":"Failed To Add Group: {errorMsg}",
    "EDIT_GROUP_FAILED":"Failed To Edit Group: {errorMsg}",
    "DE_ASSIGN_RECEIVERS_TIPS":"Are You Sure To De-Assign Receivers?",
    "DE_ASSIGN_RECEIVERS_INFO":"Are You Sure To De-Assign The Selected Receivers?",
    "ASSIGN_RECEIVERS_TIPS":"Are You Sure To Assign Receivers?",
    "ASSIGN_RECEIVERS_INFO":"Are You Sure To Assign The Selected Receivers?",
    "ASSIGN_RECEIVERS_SUCCESS":"Receivers Assigned Successfully!",
    "ASSIGN_RECEIVERS_FAILED":"Failed To Assign Receivers!",
    "DE_ASSIGN_RECEIVERS_SUCCESS":"Receivers De-Assigned Successfully!",
    "DE_ASSIGN_RECEIVERS_FAILED":"Failed To De-Assign Receivers!",
    "EDIT_YOUR_MESSAGE":"Edit Your Message",
    "USER_NOT_SITE":"Please Assign At Least One Site To The Current User First.",
    "LIMIT_LINES": "Cannot exceed {lines} lines",
    "GROUP_NAME_EXISTS":"Group name already exists!",
    "GROUP_NAME_LENGTH":"Group name must be 2-36 characters",
    "TITLE_NAME_LENGTH":"Title name must be 1-36 characters",
    "SELECT_RECEIVER_WARNING":"Please select at least one receiver",
    "START_TIME_ERROR": "Start time must be set to a future time.",
    "START_DATE_ERROR": "Start date must be set to a future date.",
    "RECURRING_TIME_ERROR": "Please select at least one day of the week.",
    "RECEIVERS_NAME":"Receivers Name",

    //MESSENGER STATUS
    "MESSENGER_pending": "Pending",
    "MESSENGER_inqueue": "In Queue",
    "MESSENGER_inprocess": "In Process",
    "MESSENGER_stopbyuser": "Stopped By User",
    "MESSENGER_half-complete": "Half-Complete",
    "MESSENGER_complete": "Complete",
    "MESSENGER_failed": "Failed",
    "MESSENGER_unknown": "Unknown",

    //SIGNGE STATUS
    "SIGNAGE_pending": "Pending",
    "SIGNAGE_inqueue": "In Queue",
    "SIGNAGE_inprocess": "In Process",
    "SIGNAGE_stopbyuser": "Stopped By User",
    "SIGNAGE_half-complete": "Half-Complete",
    "SIGNAGE_complete": "Complete",
    "SIGNAGE_failed": "Failed",
    "SIGNAGE_unknown": "Unknown",

    //Signage Plus
    "SIGNAGE_PLUS": "Signage Plus",
    "CREATE_SIGNAGEE": "Create Signage",
    "SIGNAGE_CREATE_PLAYLIST": "Create Playlist",
    "DRAFTS": "Drafts",
    "MediaLibrary": "Media Library",
    "PLAY_DIGITAL_SIGNAGE": "Play Digital Signage",
    "PAUSE_DIGITAL_SIGNAGE": "Pause Digital Signage",
    "STOP_DIGITAL_SIGNAGE": "Stop Digital Signage",
    "CONFIRM_PLAY_SIGNAGE": "Confirm Play Signage",
    "CONFIRM_PLAY_SIGNAGE_DESC": "Are you sure you want to start digital signage on the selected receivers?",
    "CONFIRM_PAUSE_SIGNAGE": "Confirm Pause Signage",
    "CONFIRM_PAUSE_SIGNAGE_DESC": "Are you sure you want to pause digital signage on the selected receivers?",
    "CONFIRM_STOP_SIGNAGE": "Confirm Stop Signage", 
    "CONFIRM_STOP_SIGNAGE_DESC": "Are you sure you want to stop digital signage on the selected receivers?",
    "PLAY": "Play",
    "STOP": "Stop",
    "RECEIVER_NAME": "Receiver Name",
    "ASSIGNED_GROUP": "Assigned Group",
    "CURRENT_STATUS": "Current Status",
    "CURRENT_SIGNAGE_PLAYING": "Current Signage Playing",
    "ACTIONS": "Actions",
    "TOTAL_RECEIVERS": "Total Receivers",
    "TOTAL_USERS": "Total Users",
    "TOTAL_GROUPS": "Total Groups",
    "STORAGE_USED": "Storage Used",
      "ACTIVE": "Active",
    "INACTIVE": "Inactive",  
    "IDLE": "Idle",
    "STOPPED": "Stopped",
    "OFFLINE": "Offline",
    "USERS": "Users",
    "SIGNAGE": "Signage",
    "SCHEDULED": "Scheduled",
    "GROUPS": "Groups",
    "STATUS": "Status",
    "RECEIVERS": "Receivers",
    "ML_REMOVE_TIPS":"Are You Sure?",
    "ML_REMOVE_INFO":"Are You Sure To Remove The Selected Media File?",
    "ML_MOVE_FILES_INFO":"Are You Sure Move The Selected Media File?",
    "ALL_FILES": "All files",
    "ADD_FOLDER_FAILED":"Failed To Add Folder: {errorMsg}",
    "EDIT_FOLDER_FAILED":"Failed To Edit Folder: {errorMsg}",
    "DELETE_FOLDER_FAILED":"Failed To Delete Folder: {errorMsg}",
    "ADD_FOLDER_SUCCESS":"Folder Added Successfully!",
    "EDIT_FOLDER_SUCCESS":"Folder Edited Successfully!",
    "DELETE_FOLDER_SUCCESS":"Folder Deleted Successfully!",
    "REMOVE_FILE_SUCCESS":"Successfully remove files.",
    "REMOVE_FILE_FAILED":"Failed to remove files.",
    "MOVE_FILES_SUCCESS":"Successfully move files to {folderName}.",
    "MOVE_FILES_FAILED":"Failed to move files to {folderName}.",
    "PLEASE_WAIT_FOR_PREVIOUS_UPLOAD": "Please waiting for the previous upload to complete.",
    "ADD_NEW_FOLDER":"Add New Folder",
    "FOLDER_NAME_EXISTS":"Folder name already exists!",
    "FOLDER_NAME_LENGTH":"Folder name must be 2-36 characters",
    "MEDIA_NAME":"Media Name",
    "MEDIA_TYPE":"Type",
    "MEDIA_SIZE":"Size",
    "UPLOADED_DATE":"Uploaded Date",
    "MOVE_FILES":"Move Files",
    "REMOVE_FILES":"Remove",
    "FOLDER":"Folder",
    "FOLDER_NAME":"Folder Name",
    "ADD_FILES":"Add Files",
    "UPLOAD_FILE":"upload file",
    "PLAYLISTS":"Playlists",
    "MEDIA":"Media",
    "WIDGETS":"Widgets",
    "CANVA":"Canva",
    "LINKS":"Links",
    "PLAYLIST": "Playlist",
    "LOOP_PLAYLIST":"Loop Playlist",
    "MEDIA_NAME_LENGTH":"Media name must be 2-36 characters",
    "EDIT_FOLDER":"Edit",
    "EDIT_MEDIA":"Edit Media",
    "ADD_PLAYLIST":"Add Playlist",
    "ADD_LINKS":"Add Links",
    "IMPORT_FROM_CANVA":"Import From Canva",
    "MINUTES":"Minutes",
    "SECONDS":"Seconds",
    "HOURS":"Hours",
    "RENAME":"Rename",
    "REMOVE":"Remove",
    "PLAYLIST_NAME":"Playlist Name",
    "ADD_NEW_PLAYLIST":"Add New Playlist",
    "PLAYLIST_NAME_LENGTH":"Playlist name must be 2-36 characters",
    "ADD_PLAYLIST_SUCCESS":"Playlist Added Successfully!",
    "ADD_PLAYLIST_FAILED":"Failed To Add Playlist: {errorMsg}",
    "LINK_NAME":"Name",
    "LINK":"Link",
    "LINK_SELECT":"Select",
    "LINK_EMBEDDED_CODE":"Embedded Code",
    "SELECT_TYPE_LINK":"Select Type Of Link",
    "IMAGES":"Images",
    "MP4":"Mp4",
    "YOUTUBE":"Youtube",
    "VIMEO":"Vimeo",
    "DRAFT_NAME":"Draft Name",
    "CREATED_BY":"Created By",
    "LAST_EDITED":"Last Edited",
    "CREATE_NEW_SIGNAGE":"Create New Signage",
    "REMOVE_DRAFTS":"Are You Sure To Remove The Selected Signage?",
    "SIGNAGE_NAME":"Signage Name",
    "TYPE_HERE":"Type here",
    "ZONE_1_SIGNAGE": "1 Zone (Signage Only)",
    "ZONE_2_SIGNAGE_WIDGET": "2 Zone (Signage + tall widget )",
    "ZONE_3A_SIGNAGE_2WIDGET": "3 Zone (1) (Signage + 2 widgets )",
    "ZONE_3B_SIGNAGE_WIDGET_TICKER": "3 Zone (2) (signage  + tall widget + Ticker)",
    "ZONE_4_SIGNAGE_2WIDGET_TICKER": "4 Zone (signage + 2 widgets + 1 ticker )",
    "SCHEDULE_SIGNAGE":"Schedule Signage",
    "MAIN_SIGNAGE_CONTENT":"Main Signage Content",
    "ADD_SCROLLING_MESSAGE":"Add Scrolling Message",
    "UPLOAD_FILE_SUCCESS":"File Uploaded Successfully!",
    "UPLOAD_FILE_FAILED":"Failed To Upload File: {errorMsg}",
    "ADD_WIDGET":"Add Widget",
    "CLOCK":"Clock",
    "CALENDAR":"Calendar",
    "SIGNAGE_WEATHER":"Weather",
    "ANALOG": "Analog",
    "DIGITAL": "Digital",
    "12_HOUR": "12-Hour",
    "24_HOUR": "24-Hour",
    "SELECT_CLOCK_TYPE":"Select Clock Type",
    "TIME_FORMAT": "Time Format",
    "TIMEZONE": "Timezone",
    "SEARCH_CITY": "Search for a city",
    "RECENT": "Recent",
    "NEW_PLAYLIST":"Playlist:",
    "LOOP": "Loop",
    "SAVE_PLAYLIST":"Save Playlist",
    "ACTIVE":"Active",
    "INACTIVE":"Inactive",
    "GB":"GB",
    "TOTAL_PLAYLISTS":"Total Playlists",
    "STORAGE_USED":"Storage Used",
    "SIGNAGE": "Signage",
    "SCHEDULED":"Scheduled",
    "Signage History":"History (Last 50 Signage)",
    "FAILED_RECEIVERS":"Failed Receivers",
    "PREVIOUS":"Previous",
    "DATE&TIME":"Date & Time",
    "DESTINATION":"Destination",
    "OVERVIEW":"Overview",
    "SCHEDULE_SIGNAGE_HINT":"Choose A Date And Time When You Would Like To Schedule The Signage",
    "STARTING_DATE":"Starting Date",
    "STARTING_TIME":"Daily Start Time",
    "ENDING_DATE":"Ending Date",
    "ENDING_TIME":"Daily End Time",
    "REPEAT":"Repeat",
    "DAILY":"Daily",
    "CUSTOM_DAYS":"Custom Days",
    "SELECT_ALL_DEPARTMENTS":"Select All Departments",
    "SELECT_LOCATION_HINT":"Select a location from the list below",
    "DESTINATIONS":"Destinations",
    "REPEAT_ON":"Repeat on",
    "SUNDAY":"Sunday",
    "MONDAY":"Monday",
    "TUESDAY":"Tuesday",
    "WEDNESDAY":"Wednesday",
    "THURSDAY":"Thursday",
    "FRIDAY":"Friday",
    "SATURDAY":"Saturday",
    "NEXT": "Next",
    "ADD_CALENDAR":"Add Calendar",
    "ADD_ALL_PROCEED.":"Add All To Proceed.",
    "SELECT_ZONE":"Select Anyone Zone To Proceed.",
    "SIGNAGE_SCHEDULED":"New Signage Scheduled Successfully!",
    "SIGNAGE_SCHEDULED_FAILED":"Failed To Schedule Signage: {errorMsg}",
    "SIGNAGE_SCHEDULED_DESCRIPTION":"New Signage Has Been Scheduled Successfully.",
    "TICKER_MESSAGE":"Ticker Message",
    "ADD_TICKER_MESSAGE":"Add Ticker Message",
    "TYPE_MESSAGE":"Type Message",
    "TICKER_MESSAGE_LENGTH":"Ticker message must be 2-256 characters",
    "TICKER_MESSAGE_SUCCESS":"Ticker message added successfully!",
    "CHARACTERS_REMAINING":"characters remaining",
    "SELECT_SITE":"Select Site",
    "ADD_LINK_SUCCESS":"Link added successfully!",
    "ADD_LINK_FAILED":"Failed to add link: {errorMsg}",
    "EDIT_PLAYLIST":"The new playlist has not changed. Please make changes to the playlist before saving.",
    "RENAME_PLAYLIST_FAILED":"Failed to rename playlist. Please try again.",
    "PLAYLIST_SAVE_ERROR":"Failed to save playlist. Please try again.",
    "PLAYLIST_SAVE_SUCCESS": "Playlist saved successfully!",
    "SIGNAGE_inactive": "Inactive",
    "SIGNAGE_active": "Active",
    "SIGNAGE_running": "Running",
    "SIGNAGE_scheduled": "Scheduled",
    "CUSTOM_user_no_roles": "The user has not been assigned a role.",
    "CUSTOM_user_no_sites": "The user has not been assigned a site.",
    "SELECT_PLAYLIST":"Please select a playlist.",
    "LINK_NAME_LENGTH": "Link name must be 2-36 characters",
    "ADD_CALENDAR_SUCCESS":"Calendar added successfully!",
    "ADD_CALENDAR_FAILED":"Failed to add calendar: {errorMsg}",
    "EDIT_CALENDAR_SUCCESS":"Calendar edited successfully!",
    "EDIT_CALENDAR_FAILED":"Failed to edit calendar: {errorMsg}",
    "ADD_CLOCK_SUCCESS":"Clock added successfully!",
    "ADD_CLOCK_FAILED":"Failed to add clock: {errorMsg}",
    "EDIT_CLOCK_SUCCESS":"Clock edited successfully!",
    "EDIT_CLOCK_FAILED":"Failed to edit clock: {errorMsg}",
    "ADD_WEATHER_SUCCESS":"Weather added successfully!",
    "ADD_WEATHER_FAILED":"Failed to add weather: {errorMsg}",
    "EDIT_WEATHER_SUCCESS":"Weather edited successfully!",
    "EDIT_WEATHER_FAILED":"Failed to edit weather: {errorMsg}",
    "SELECT_CITY_INCORRECT":"The selected city is incorrect.",
    "DELETE_SIGNAGE": "Are You Sure To Delete This Signage?",
    "DELETE_SIGNAGE_DESCRIPTION": "This Will Delete The Signage Permanently. You Can Not Undo This Action.",
    "SELECT_WIDGET": "Please select a widget.",
    "SIGNAGE_NAME_LENGTH_ERROR": "Signage name must be 2-36 characters",
    "REPLACE_TICKER_MESSAGE": "Replace Ticker Message",
    "REPLACE_PLAYLIST": "Replace Playlist",
    "REPLACE_WIDGET": "Replace Widget",
    "SIGNAGE_DELETED_SUCCESSFULLY": "Signage deleted successfully!",
    "SIGNAGE_DELETED_FAILED": "Failed to delete signage: {errorMsg}",
    "SAVE_TO_DRAFTS": "Save to Drafts",
    "SELECTED_PLAYLIST_NULL": "The Selected Playlist Is Null. Please Choose Again.",
    "SignageScheduled": "Scheduled",
    "STOP_SIGNAGE": "Are you sure you want to stop this signage?",
    "STOP_SIGNAGE_DESCRIPTION": "This will temporarily stop the signage until the next scheduled time.",
    "STOP": "Stop",
    "DELIVERY": "Delivery",
    "SIGNAGE_STOPPED_SUCCESSFULLY": "Signage stopped successfully",
    "SIGNAGE_STOPPED_FAILED": "Failed to stop signage: {errorMsg}",
    "FEATURE_ADMIN_NO_SITE": "ALL Feature Users MUST have roles AND Sites assigned to them.",
    "NO_SITE_ASSOCIATED": "No Site associated with your account. Please contact your IT Administrator to Assign a Site to your account",
    "SIGNAGE_CREATOR": "Signage Creator",
    "SIGNAGE_CREATOR_DESCRIPTION": "Your Signage conflicts with an existing Signage. Please contact your Signage Plus Owner or select different time or Receiver.",
    "EDIT":"Edit",
    "EDIT_LINK": "Edit Link",
    "EDIT_LINK_SUCCESS":"Edit Link Success",
    "EDIT_LINK_FAILED":"Failed to edit link: {errorMsg}",
    "DELETE_LINK_FAILED":"Failed to delete link: {errorMsg}",
    "DELETE_GROUP_TIPS":"Are You Sure To Delete This Group?",
    "DELETE_GROUP_INFO":"This Will Delete The Group Permanently. You Can Not Undo This Action.",
    "DELETE_GROUP_SUCCESS":"Group Deleted Successfully!",
    "DELETE_GROUP_FAILED":"Failed To Delete Group: {errorMsg}",
    "STARTING_TIME_ERROR": "Starting time must be before ending time.",
    "NEXT_RUN_EXCEED_ENDING_TIME": "Next run time exceeds ending time.",
    "CONNECT_WITH_CANVA":"Connect With Canva",
    "SIGNOUT_FROM_CANVA":"Signout From Canva",
    "TOTAL_SIZE":"Total Size: {totalSize}",
    "SELECTED_SIZE":"Selected Size: {selectedSize}",
    "SIGNAGE_NAME_REQUIRED":"Signage Name is required.",
    "SIGNAGE_SCHEDULE_MESSAGE": "Schedule signage now?",
    "SIGNAGE_SCHEDULE_WARNING": "Unsaved work will be lost. Schedule signage now?",
    "EXIT": "Exit",
    "LOADING": "Loading...",
    "LOADING_CONTENT": "Loading content...",
    "UNTITLED_DESIGN": "Untitled Design",
    "SAVING": "Saving",
    "CONFIRM_SAVE": "Do you want to save?",
    "CONFIRM_SAVE_BEFORE_EXIT": "Do you want to save before leaving?",
    "RECENT_DESIGNS": "Recent Designs",
    "UPLOADED_BY": "Uploaded By",
    "GROUP_NAME_ALREADY_EXISTS": "Group name already exists. Please enter a unique name.",
    "GROUP_NAME_NO_SPACE": "The group name cannot start with a space.",
    "EMAIL_BELONGS_TO_ANOTHER_ORG": "Email belongs to another organization",
    //Signage Admin Dashboard
    "STOP_SIGNAGE_NO_RX_WARNING":"Please select at least one receiver to stop signage",
    "STOP_SIGNAGE_NO_ACTIVE_RX_WARNING":"No receiver(s) can be stopped (only active receivers can be stopped)",
    "SIGNAGE_CONFLICT_WARNING":"Your Signage conflicts with an existing Signage. Please contact Signage Creator or select a different time or Receiver.",

    // Trial Provisioning
    "TRIAL_PROVISIONING":"Trial Provisioning",
    "ENTER_USER_INFORMATION":"Enter User Information",
    "ACCOUNT_OWNER_EMAIL":"Account Owner Email",
    "ACCOUNT_OWNER_EMAIL_PLACEHOLDER":"accountowner@organization.com",
    "ACCOUNT_OWNER_EMAIL_HINT":"The trial users will be associated with this account owner's account. Your last entry will be remembered.",
    "ACCOUNT_OWNER_EMAIL_REQUIRED":"Account owner email is required",
    "VALIDATING":"Validating...",
    "VALIDATE":"Validate",
    "USER_1_INFORMATION":"User #1 Information",
    "USER_2_INFORMATION":"User #2 Information",
    "JOHN":"John",
    "DOE":"Doe",
    "JANE":"Jane",
    "SMITH":"Smith",
    "USER_1_EMAIL":"user1@organization.com",
    "USER_2_EMAIL":"user2@organization.com",
    "ACCOUNT_1_ROLES":"Account #1 will receive roles: SBMM Front Desker, Signage Plus Owner, Alert Plus Safety Officer",
    "ACCOUNT_2_ROLES":"Account #2 will receive roles: Alert Plus Teacher",
    "ORGANIZATION_NAME":"Organization Name",
    "ORGANIZATION_NAME_HINT":"Organization Name for Groups",
    "ORGANIZATION_NAME_REQUIRED":"Organization Name is required",
    "ORGANIZATION_NAME_LENGTH":"Organization Name must be 2-36 characters",
    "ORGANIZATION_NAME_NO_SPACE":"The organization name cannot start with a space",
    "ORGANIZATION_NAME_ALREADY_EXISTS":"Organization name already exists. Please enter a unique name.",
    "TRIAL_INFO":"Trial Provisioning Tool Information",
    "ACCOUNT_1":"Account 1",
    "ACCOUNT_2":"Account 2",
    "EMAIL":"Email",
    "PASSWORD":"Password",
    "COPIED":"Copied!",
    "COPY":"Copy",
    "CREATED_GROUPS":"Created Groups",
    "IMPORTANT":"Important",
    "SAVE_CREDENTIALS_WARNING":"Please save these credentials immediately. They will not be shown again for security reasons.",
    "ALL_CREDENTIALS_COPIED":"All Credentials Copied!",
    "TRIAL_CREDENTIALS_HEADER":"Trial Account Credentials for {orgName}",
    "TRIAL_CREDENTIALS_SEPARATOR":"========================================",
    "TRIAL_ACCOUNT_1_LABEL":"Account 1",
    "TRIAL_ACCOUNT_2_LABEL":"Account 2",
    "TRIAL_EMAIL_LABEL":"Email: {email}",
    "TRIAL_PASSWORD_LABEL":"Password: {password}",
    "TRIAL_GENERATED_ON":"Generated on: {date}",
    "COPY_ALL_CREDENTIALS":"Copy All Credentials",
    "TRIAL_CREATES_2_ACCOUNTS":"Creates 2 SBCloud accounts with randomly generated strong passwords",
    "TRIAL_ACCOUNT_1_ROLES":"Account #1: SBMM Front Desker, Signage Plus Owner, Alert Plus Safety Officer",
    "TRIAL_ACCOUNT_2_ROLES":"Account #2: Alert Plus Teacher",
    "TRIAL_CREATES_GROUPS":"Creates Message Manager and Signage Plus groups based on organization name",
    "TRIAL_ASSIGNS_USERS":"Assigns users to appropriate groups for testing",
    "TRIAL_PASSWORD_REQUIREMENTS":"Passwords: 12 characters with uppercase, lowercase, numbers, and special characters",
    "TRIAL_UNPROVISION_WARNING":"Unprovision feature deletes accounts and groups by email/organization name",
    
    // Trial Provisioning Validation & Messages
    "FIRST_NAME_REQUIRED":"First name is required",
    "LAST_NAME_REQUIRED":"Last name is required", 
    "ORGANIZATION_NAME_REQUIRED":"Organization name is required",
    "INVALID_EMAIL_FORMAT":"Invalid email format",
    "EMAIL_ADDRESSES_MUST_BE_DIFFERENT":"Email addresses must be different",
    "EMAIL_1_REQUIRED":"Email #1 is required",
    "EMAIL_2_REQUIRED":"Email #2 is required",
    "TRIAL_ACCOUNTS_CREATED_SUCCESS":"Trial accounts successfully created! Please check your saved credentials.",
    "NO_MATCHING_ACCOUNTS_FOUND":"No matching trial accounts or groups found to delete.",
    "TRIAL_ACCOUNTS_DELETED_SUCCESS":"Trial accounts and groups successfully deleted! ({userCount} users, {groupCount} groups)",
    "UNPROVISION_CRITERIA_REQUIRED":"Please provide at least one email or organization name to unprovision",
    "FAILED_DELETE_TRIAL_ACCOUNTS":"Failed to delete trial accounts: {errorMessage}",
    "PROVISIONING":"Provisioning...",
    "PROVISION_TRIAL":"Provision Trial",
    "UNPROVISIONING":"Unprovisioning...",
    "UNPROVISION_TRIAL":"Unprovision Trial",
    "DEMO_MODAL_BUTTON":"Demo Modal",
    "ACCOUNT_CREDENTIALS":"Account Credentials",
    
    "CLOSE":"Close",
    "DEMO_MODAL":"Demo Modal",
    "ROLES":"Roles",
  }

export default en_US;